import React, { useRef, useMemo, useState, useLayoutEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ItsmInput } from "../../../../Plugin/component";
import { MentionsInput, Mention } from "react-mentions";
import { defaultStyle } from "../styles";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { MdAdd, MdClose, MdArrowDownward, MdArrowUpward } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";
import { Button, IconButton, Typography } from "@material-ui/core";
import { Chips } from "primereact/chips";

function getTypeof1() {
  return [
    "Input text",
    "Input text multiline",
    "Datetime",
    "Combobox",
    "Multiple select",
    "Lable",
    "Editor",
    "File",
    "Link",
    "Azure Email"
  ];
}

function RowPlanConfig(props) {
  const { value, onChecked, currentStep } = props;
  const reflbl = useRef();
  const refFieldName = useRef();
  const [checked, setChecked] = useState(
    value.isRequired === "true" ? true : false
  );

  useLayoutEffect(() => {
    const newChecked = value.isRequired === "true" ? true : false;
    setChecked(newChecked);
  }, [value.isRequired]);

  const handleChecked = (event) => {
    const checked = event.target.checked;
    setChecked(checked);
    currentStep
      ? props.onChange(checked, props.index, "isRequired")
      : onChecked(checked, props.index);
  };
  //ReferenedField
  const getTypeof = useMemo(() => {
    return [
      "Input text",
      "Input text multiline",
      "Datetime",
      "Combobox",
      "Multiple select",
      "Lable",
      "Editor",
      "File",
      "Link",
      "Link liên kết",
      "Azure Email"
    ];
  }, []);

  const getOninit = useMemo(() => {
    return ["Enable", "Disable"];
  }, []);

  const isPinned = useMemo(() => {
    return ["Enable", "Disable"];
  }, []);

  return (
    <div className="row rowPlanConfig" hidden = {props.value.hidden}>
      <div className="col-md-3">
        <TextField
          fullWidth
          id="outlined-name"
          label="Tên trường"
          margin="dense"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => props.onChange(e, props.index, "colunmName")}
          value={props.value.colunmName ? props.value.colunmName : ""}
          disabled={props.value.disabled}
        />
      </div>
      <div className="col-md-3">
        <Autocomplete
          options={getTypeof}
          size="small"
          getOptionLabel={(option) => option}
          style={{ width: "100%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              label="Kiểu dữ liệu"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Typography noWrap style={{ fontSize: "14px" }}>
              {option}
            </Typography>
          )}
          value={props.value.colunmType ? props.value.colunmType : ""}
          onChange={(e, newValue) =>
            props.onChange(newValue, props.index, "colunmType")
          }
          disabled={props.value.disabled}
        />
      </div>
      {props.value.colunmType &&
        (props.value.colunmType === "Combobox" ||
          props.value.colunmType === "Multiple select") && (
          <div className="col-md-3">
            <div className="chips-cus">
              <label ref={reflbl}> Dữ liệu</label>
              <Chips
                value={
                  props.value.colunmData.length > 0
                    ? props.value.colunmData
                    : []
                }
                disabled={props.value.disabled}
                onFocus={(e) => reflbl.current.classList.add("lbl-focus")}
                onBlur={(e) => reflbl.current.classList.remove("lbl-focus")}
                onChange={(e) =>
                  props.onChange(e.value, props.index, "colunmData")
                }
              ></Chips>
            </div>
          </div>
        )}
      {props.value.colunmType && props.value.colunmType !== "Link liên kết" && (
        <div className="col-md-3">
          <Autocomplete
            options={[
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ]}
            size="small"
            getOptionLabel={(option) => option}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="dense"
                label="Độ rộng"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <Typography noWrap style={{ fontSize: "14px" }}>
                {option}
              </Typography>
            )}
            value={props.value.colunmWidth ? props.value.colunmWidth : ""}
            onChange={(e, newValue) =>
              props.onChange(newValue, props.index, "colunmWidth")
            }
          />
        </div>
      )}
      {/* Config Reference */}
      {props.value.colunmType && props.value.colunmType === "Link liên kết" && (
        <div className="col-md-12">
          <div className="row rowPlanConfig-noborder">
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-url"
                label="Link API"
                margin="dense"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={props.value.colunmData ? props.value.colunmData : ""}
                onChange={(e) =>
                  props.onChange(e.target.value, props.index, "colunmData")
                }
                disabled={props.value.disabled}
              />
            </div>
            <div className="col-md-3">
              <Autocomplete
                options={getOninit}
                size="small"
                getOptionLabel={(option) => option}
                style={{ width: "100%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="dense"
                    label="Chạy khi khởi tạo"
                    variant="outlined"
                  />
                )}
                renderOption={(option) => (
                  <Typography noWrap style={{ fontSize: "14px" }}>
                    {option}
                  </Typography>
                )}
                value={props.value.KT}
                onChange={(e, newValue) =>
                  props.onChange(newValue, props.index, "initFlag")
                }
                disabled={props.value.disabled}
              />
            </div>
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-field-dependence"
                label="Trường phụ thuộc"
                margin="dense"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ display: "none" }}
                value={props.value.refName}
                onChange={(e) =>
                  props.onChange(e.target.value, props.index, "referenceField")
                }
                disabled={props.value.disabled}
              />
            </div>
            <div className="col-md-12">
              <div className="col-md-12">
                <div className="col-md-12 typographyStyle rowPlanConfig-noborder">
                  <Typography component="div">
                    <p>INPUT</p>
                  </Typography>
                </div>
                {props.value.input &&
                  props.value.input.map((item, index) => {
                    // console.log("item1111", item);
                    return (
                      <>
                        <div className="row rowPlanConfig">
                          <div className="col-md-3">
                            <ItsmInput
                              label="Tên trường"
                              className="action-config-input"
                              ref={refFieldName}
                              required
                            >
                              <MentionsInput
                                allowSpaceInQuery={true}
                                singleLine={true}
                                value={item.feedPlanInputConfig}
                                onFocus={() =>
                                  refFieldName.current.classList.add(
                                    "itsm-input-focus"
                                  )
                                }
                                onBlur={() =>
                                  refFieldName.current.classList.remove(
                                    "itsm-input-focus"
                                  )
                                }
                                onChange={(e) =>
                                  props.onChange(
                                    e.target.value,
                                    props.index,
                                    "FeedPlanInputConfig",
                                    index
                                  )
                                }
                                style={defaultStyle}
                              >
                                <Mention
                                  trigger="[["
                                  data={props.FeedsConfigField.feedsDataDisplay}
                                  markup="[[__display__]]"
                                  //style={defaultMentionStyle}
                                  renderSuggestion={(e) => (
                                    <div className="custom-item">
                                      <div className="custom-item-username">
                                        {e.display
                                          .replace("[[", "")
                                          .replace("]]", "")}
                                      </div>
                                    </div>
                                  )}
                                />
                              </MentionsInput>
                            </ItsmInput>
                          </div>

                          <div className="btn-handle">
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-up-config"
                              onClick={() =>
                                props.btnUpInput(props.index, index)
                              }
                            >
                              <MdArrowUpward />
                            </IconButton>
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-down-config"
                              onClick={() =>
                                props.btnDownInput(props.index, index)
                              }
                            >
                              <MdArrowDownward />
                            </IconButton>
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-delete-config"
                              onClick={() =>
                                props.btnDeleteInput(props.index, index)
                              }
                            >
                              <MdClose />
                            </IconButton>
                          </div>
                        </div>
                      </>
                    );
                  })}
                <div className="row rowPlanConfig-noborder">
                  <div className="col-md-12">
                    <Button
                      variant="contained"
                      className="btn-next"
                      startIcon={<MdAdd />}
                      onClick={() =>
                        props.HandleAddConfigInputData(props.index)
                      }
                    >
                      Thêm
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="col-md-12 typographyStyle rowPlanConfig-noborder">
                  <Typography component="div">
                    <p>OUTPUT</p>
                  </Typography>
                </div>
                {props.value.output &&
                  props.value.output.map((item, index) => {
                    // console.log("item", item)
                    return (
                      <>
                        <div className="row rowPlanConfig">
                          <div className="col-md-2">
                            <TextField
                              fullWidth
                              id="output-outlined-linked-name"
                              label="Tên trường"
                              margin="dense"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              required
                              value={item.colunmName}
                              disabled={item.disabled}
                              onChange={(e) =>
                                props.onChange(
                                  e,
                                  props.index,
                                  "outputColunmName",
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <Autocomplete
                              options={getTypeof1()}
                              size="small"
                              getOptionLabel={(option) => option}
                              style={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  margin="dense"
                                  label="Kiểu dữ liệu"
                                  variant="outlined"
                                />
                              )}
                              renderOption={(option) => (
                                <Typography noWrap style={{ fontSize: "14px" }}>
                                  {option}
                                </Typography>
                              )}
                              // value={props.value.colunmType}
                              value={item.colunmType}
                              onChange={(e, newValue) =>
                                props.onChange(
                                  newValue,
                                  props.index,
                                  "outputcolunmType",
                                  index
                                )
                              }
                              disabled={item.disabled}
                            />
                          </div>
                          {item.colunmType &&
                            (item.colunmType === "Combobox" ||
                              item.colunmType === "Multiple select") && (
                              <div className="col-md-2">
                                <TextField
                                  fullWidth
                                  id="output-outlined-linked-mapping"
                                  label="Dữ liệu"
                                  margin="dense"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={item.colunmData}
                                  disabled={item.disabled}
                                  onChange={(e) =>
                                    props.onChange(
                                      e,
                                      props.index,
                                      "outputmapping",
                                      index
                                    )
                                  }
                                />
                              </div>
                            )}
                          <div className="col-md-2">
                            <TextField
                              fullWidth
                              id="output-outlined-linked-mapping"
                              label="Dữ liệu mặc định"
                              margin="dense"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={item.value}
                              disabled={item.disabled}
                              onChange={(e) =>
                                props.onChange(
                                  e,
                                  props.index,
                                  "outputcolunmData",
                                  index
                                )
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <Autocomplete
                              options={[
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12",
                              ]}
                              size="small"
                              getOptionLabel={(option) => option}
                              style={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  margin="dense"
                                  label="Độ rộng"
                                  variant="outlined"
                                />
                              )}
                              renderOption={(option) => (
                                <Typography noWrap style={{ fontSize: "14px" }}>
                                  {option}
                                </Typography>
                              )}
                              value={item.colunmWidth}
                              // value={props.value.colunmWidth}
                              onChange={(e, newValue) =>
                                props.onChange(
                                  newValue,
                                  props.index,
                                  "outputcolunmWidth",
                                  index
                                )
                              }
                            />
                          </div>

                          <div className="btn-handle">
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-up-config"
                              onClick={() =>
                                props.btnUpOutput(props.index, index)
                              }
                            >
                              <MdArrowUpward />
                            </IconButton>
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-down-config"
                              onClick={() =>
                                props.btnDownOutput(props.index, index)
                              }
                            >
                              <MdArrowDownward />
                            </IconButton>
                            <IconButton
                              disabled={props.value.disabled}
                              size="small"
                              aria-label=""
                              className="btn-delete-config"
                              onClick={() =>
                                props.btnDeleteOuputConfig(props.index, index)
                              }
                            >
                              <MdClose />
                            </IconButton>
                          </div>
                        </div>
                      </>
                    );
                  })}
                <div className="row rowPlanConfig-noborder">
                  <div className="col-md-12">
                    <Button
                      variant="contained"
                      className="btn-next"
                      startIcon={<MdAdd />}
                      onClick={() =>
                        props.btnAddConfigDataOuput(props.index, "")
                      }
                    >
                      Thêm
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* End Config Reference */}

      <div className="col-md-3">
        {/* <FormControlLabel
                label="Bắt buộc nhập"
                control={<Checkbox checked={checked} onChange={(e) => props.onChange(e, props.index, "isRequired")}/>}
            /> */}
        {currentStep && (
          <Autocomplete
            options={isPinned}
            size="small"
            getOptionLabel={(option) => option}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="dense"
                label="Hiển thị lên kết quả báo cáo"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <Typography noWrap style={{ fontSize: "14px" }}>
                {option}
              </Typography>
            )}
            value={props.value.configTypeID === 4 ? "Enable" : "Disable"}
            onChange={(e, newValue) =>
              props.onChange(newValue, props.index, "isAvailabelDisplay")
            }
          />
        )}
        {!currentStep && (
          <FormControlLabel
            label="Bắt buộc nhập"
            control={<Checkbox checked={checked} onChange={handleChecked} />}
          />
        )}
      </div>
      {currentStep && (
        <div className="col-md-3">
          <FormControlLabel
            label="Bắt buộc nhập"
            control={<Checkbox checked={checked} onChange={handleChecked} />}
          />
        </div>
      )}
      <div className="btn-handle">
        <IconButton
          disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-up-config"
          onClick={() => props.onClickUp(props.index)}
        >
          <MdArrowUpward />
        </IconButton>
        <IconButton
          disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-down-config"
          onClick={() => props.onClickDown(props.index)}
        >
          <MdArrowDownward />
        </IconButton>
        {!currentStep && (
          <>
            <IconButton
              disabled={props.value.disabled}
              size="small"
              aria-label=""
              className="btn-delete-config"
              onClick={() =>
                props.onClickDelete({
                  index: props.index,
                  name: props.value.colunmName,
                })
              }
            >
              <MdClose />
            </IconButton>
          </>
        )}
        {currentStep && (
          <IconButton
            disabled={props.value.disabled}
            size="small"
            aria-label=""
            className="btn-delete-config"
            onClick={() => props.onClickDelete(props.index)}
          >
            <MdClose />
          </IconButton>
        )}
        <IconButton
              disabled={props.value.disabled}
              size="small"
              ff
              aria-label=""
              className="btn-copy-config"
              onClick={() => props.onClickCopy(props.index)}
            >
              <AiOutlinePlus />
        </IconButton>
      </div>
    </div>
  );
}

export default RowPlanConfig;
